import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { A as ActionType } from './types-nwm8HIz7.js';
import { CoreContext } from './context/index.js';
import { selectCart } from './storeSelectors/cart.js';
import { w as withProviders } from './withProviders-l3mjYkR2.js';

const CartDrawerButton = ({ onKeyUp, setActionType }) => {
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { t: tHeading } = useTranslation('', { keyPrefix: '$common.$headings' });
    const { useSelector } = useContext(CoreContext);
    const cart = useSelector(selectCart);
    const quantity = cart.total_quantity;
    return (React.createElement("div", { id: "shopping-bag", "aria-label": tLabel('miniShoppingCartAriaLabel') },
        React.createElement("button", { type: "button", className: "ab-icon button-shopping-bag button-reset", onKeyPress: event => onKeyUp(event, ActionType.ShoppingCart), onClick: () => setActionType(ActionType.ShoppingCart) },
            React.createElement("span", { className: "icon-bag", title: tHeading('shoppingCart') }),
            quantity ? (React.createElement("div", { className: "cart-items-amount", "data-testid": "cart-items-amount" },
                React.createElement("span", { className: "sr-only" },
                    tLabel('items'),
                    ":"),
                " ",
                quantity)) : (React.createElement("span", { className: "sr-only" }, tLabel('miniShoppingCartAriaLabel'))))));
};
var ShoppingCartDrawerButton = withProviders(CartDrawerButton, { translation: true, snackbar: true });

export { ShoppingCartDrawerButton as S };
//# sourceMappingURL=CartDrawerButton-2eYmUV78.js.map
